import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M8.35694357,11.817929 C10.7607721,11.817929 12.7094602,9.86924094 12.7094602,7.46541237 L12.7094602,1.75 L11.1470183,1.75 L11.1470183,7.46541237 C11.1470183,9.00632812 9.89785931,10.2554871 8.35694357,10.2554871 C6.81602782,10.2554871 5.56686879,9.00632812 5.56686879,7.46541237 L5.56686879,1.75 L4.00442692,1.75 L4.00442692,7.46541237 C4.00442692,9.86924094 5.953115,11.817929 8.35694357,11.817929 Z M13.2674752,12.8571761 L3.44641196,12.8571761 C3.19986544,12.8571761 3,13.0570415 3,13.303588 C3,13.5501346 3.19986544,13.75 3.44641196,13.75 L13.2674752,13.75 C13.5140217,13.75 13.7138871,13.5501346 13.7138871,13.303588 C13.7138871,13.0570415 13.5140217,12.8571761 13.2674752,12.8571761 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}
const FontUderlineIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontUderlineIcon
